import { useEffect, useState } from "react";
import TableCard from "../../components/TableCard";
import styles from "./styles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import DateRangeIcon from "@mui/icons-material/DateRange";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import { Dialog, DialogContent } from "@mui/material";
import WhiteButton from "../../components/WhiteButton";
import BlueButton from "../../components/BlueButton";
import CheckIcon from "@mui/icons-material/Check";
import GenericDatePicker from "../../components/GenericDatePicker";
import ModalContratos from "../Juridico/ModalContratos";
import Step2 from "../AnexoContrato/Step2";
import {
  alteraDataExpiracao,
  alteraSignatarios,
  buscaSignatarios,
  buscaTodosContratos,
  cancelaContrato,
} from "../../services/api-contratos.service.js";
import { debounce, set } from "lodash";
import { TramTwoTone } from "@mui/icons-material";
import {
  buscarUsuarios,
  buscarUsuariosPorTexto,
} from "../../services/api-planejamento-tributario.service.js";
import SnackBar from "../../components/SnackBar/index.js";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { formatValue } from "../../utils/formatValue.js";
import { buscarComboPorCodigo } from "../../services/auth.service.js";
import Loading from "../../components/Loading/index.js";

const Contratos = () => {
  const [data, setData] = useState([]);
  const [openCancel, setOpenCancel] = useState(false);
  const [openAlterar, setOpenAlterar] = useState(false);
  const [openContrato, setOpenContrato] = useState(false);
  const [right, setRight] = useState([]); // enviar right para req de alteração de signatarios
  const [openSignatarios, setOpenSignatarios] = useState(false);
  const [selecionarData, setSelecionarData] = useState({
    value: "",
    error: false,
  });
  const [dadosUsuarios, setDadosUsuarios] = useState({ id: "", tipo: "" });
  const [loading, setLoading] = useState(false);
  const [contratoSelecionado, setContratoSelecionado] = useState({
    idContrato: null,
    nomeEmpresa: "",
  });
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const [stepSelected, setStepSelected] = useState(1);

  useEffect(() => {
    const handlesignatarios = async () => {
      try {
        const responseSignatarios = await buscaSignatarios(
          contratoSelecionado.idContrato
        );

        const signatarios = responseSignatarios.signatarios
          .map((item) => {
            return {
              id: item.idUsuario,
              nome: item.nome,
              email: item.email,
              status: item.status,
              tipoSignatario: item.tipoSignatario,
            };
          })
          .filter((item) => item.status !== "Cancelado");

        setRight(signatarios);
      } catch (error) {
        setObjSnackBar({ type: "error", msg: error.response.data.mensagem });
      }
    };
    if (openSignatarios === true) {
      handlesignatarios();
    } else {
      setRight([]);
    }
  }, [openSignatarios]);

  const formatDate = (date) => {
    const newDate = new Date(date);

    return newDate.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatDateString = (date) => {
    const [ano, mes, dia] = date.split("-");
    return `${dia}/${mes}/${ano}`;
  };

  const handleAlterStep = (step) => {
    setStepSelected(step);
  };

  const handleOrganizaData = (response) => {
    const dataOrganizada = response.map((item) => {
      let statusResponse = "";
      const buttons = [
        {
          icon: <HistoryEduIcon />,
          title: "CONTRATO",
          onClick: () =>
            handleOpenCloseContrato(
              true,
              item.idContrato,
              item.razaoSocial,
              item.idUsuario,
              item.tipoUsuario
            ),
        },
      ];
      if (item.status !== "Cancelado") {
        buttons.unshift(
          {
            icon: <CloseIcon />,
            title: "CANCELAR CONTRATO",
            onClick: () =>
              handleOpenCloseCancel(true, item.idContrato, item.razaoSocial),
          },
          {
            icon: <DateRangeIcon />,
            title: "ALTERAR EXPIRAÇÃO",
            onClick: () => handleOpenCloseAlterar(true, item.idContrato),
          },
          {
            icon: <RecentActorsIcon />,
            title: "SIGNATÁRIOS",
            onClick: () => handleOpenCloseSignatarios(true, item.idContrato),
          }
        );
      }
      switch (item.status) {
        case "Pendente Assinatura": {
          statusResponse = (
            <div className={styles.status}>
              <span className={styles.pendente} /> {item.status}
            </div>
          );
          break;
        }
        case "Assinado": {
          statusResponse = (
            <div className={styles.status}>
              <span className={styles.assinado} /> {item.status}
            </div>
          );
          break;
        }
        case "Cancelado": {
          statusResponse = (
            <div className={styles.status}>
              <span className={styles.cancelado} /> {item.status}
            </div>
          );
          break;
        }
        case "Prox. do prazo de assinatura": {
          statusResponse = (
            <div className={styles.status}>
              <span className={styles.prazo} /> {item.status}
            </div>
          );
          break;
        }
        default:
          break;
      }
      return {
        tipo: item.tipoUsuario,
        empresa: item.razaoSocial,
        cnpj: formatValue("cnpj", item.cnpj),
        dtCadastro: formatDate(item.dtCadastro),
        dtPrazo: item.dtPrazo ? formatDateString(item.dtPrazo) : "-",
        status: statusResponse,
        botoes: buttons,
      };
    });
    return dataOrganizada;
  };

  const handleDadosContratos = async () => {
    try {
      setLoading(true);
      const response = await buscaTodosContratos();

      setData(handleOrganizaData(response.data));
    } catch (error) {
      setObjSnackBar({ type: "error", msg: error.response.data.mensagem });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelaContrato = async () => {
    try {
      setLoading(true);
      const response = await cancelaContrato(contratoSelecionado.idContrato);
    } catch (error) {
      setObjSnackBar({ type: "error", msg: error.response.data.mensagem });
    } finally {
      handleOpenCloseCancel(false);
      handleDadosContratos();
      setLoading(false);
    }
  };

  useEffect(() => {
    handleDadosContratos();
  }, []);

  const validDate = (inputDate) => {
    if (inputDate) {
      const date = new Date(inputDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return inputDate > today;
    } else {
      return false;
    }
  };

  const handleAlterarData = (value) => {
    setSelecionarData({
      value,
      error: validDate(value) ? false : true,
    });
  };
  const handleDebounce = debounce((value) => {
    handlePesquisaPorTexto(value);
  }, 500);

  const handlePesquisaPorTexto = async (value) => {
    try {
      setLoading(true);
      if (value === "") {
        const response = await buscaTodosContratos();
        setData(handleOrganizaData(response.data));
      } else {
        const response = await buscaTodosContratos(value);
        setData(handleOrganizaData(response.data));
      }
    } catch (error) {
      console.log(error.response.data.mensagem);
      setObjSnackBar({ type: "error", msg: error.response.data.mensagem });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitSaveSign = async () => {
    setLoading(true);
    console.log(right);

    try {
      if (right.length > 0) {
        const formatBody = right.map((item) => ({
          nome: item.nome,
          status: item.status || "Pendente Assinatura",
          email: item.email,
          idUsuario: item.id,
          tipoSignatario: item.tipoSignatario,
        }));

        const validBody = formatBody.every((obj) =>
          obj.hasOwnProperty("tipoSignatario")
        );

        console.log(validBody);

        if (validBody) {
          const response = await alteraSignatarios(
            contratoSelecionado.idContrato,
            {
              signatarios: formatBody,
            }
          );
          setObjSnackBar({ type: "success", msg: response.mensagem });
          handleOpenCloseSignatarios(false);
        } else {
          setObjSnackBar({
            type: "error",
            msg: "Um dos signatário não possui o tipo",
          });
          setLoading(false);
          return;
        }
      } else {
        return setObjSnackBar({
          type: "error",
          mensagem: "Não há nenhum signatário alocado",
        });
      }

      // setObjSnackBar({type: "success", msg: response.mensagem})
    } catch (error) {
      console.log(error.response.data.mensagem);

      setObjSnackBar({ type: "error", msg: error.response.data.mensagem });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitNewDate = async () => {
    try {
      setLoading(true);
      if (selecionarData && selecionarData.error) {
        console.log("Data inválida");
        setObjSnackBar({ type: "error", msg: "Data inválida" });
      } else {
        console.log(contratoSelecionado.idContrato);

        await alteraDataExpiracao(contratoSelecionado.idContrato, {
          newDate: selecionarData.value,
        });
      }
      handleOpenCloseAlterar(false);
    } catch (error) {
      setObjSnackBar({ type: "error", msg: error.response.data.mensagem });
    } finally {
      handleDadosContratos();
      setLoading(false);
    }
  };

  const handleOpenCloseCancel = (event, idContrato, nomeEmpresa) => {
    setOpenCancel(event);
    setContratoSelecionado({
      nomeEmpresa,
      idContrato: event ? idContrato : null,
    });
  };

  const handleOpenCloseAlterar = (estado, idContrato) => {
    setOpenAlterar(estado);
    if (estado) {
      setContratoSelecionado({
        ...contratoSelecionado,
        idContrato: idContrato,
      });
    }
  };

  const handleOpenCloseContrato = (
    event,
    idContrato,
    nomeEmpresa,
    idUsuario,
    tipoUsuario
  ) => {
    setOpenContrato(event);
    setContratoSelecionado({
      nomeEmpresa,
      idContrato: event ? idContrato : null,
    });
    setDadosUsuarios({ id: idUsuario, tipo: tipoUsuario });
  };

  const handleOpenCloseSignatarios = (estado, idContrato) => {
    setOpenSignatarios(estado);

    if (estado) {
      setStepSelected(1);
      setContratoSelecionado({
        nomeEmpresa: "",
        idContrato: idContrato,
      });
    }
  };

  const optionsFilter = [
    { value: "tipo: Cliente" },
    { value: "tipo: Parceiro" },
    { value: "tipo: Associado" },
    { value: "status: Cancelado" },
    { value: "status: Pendente Assinatura" },
    { value: "status: Assinado" },
    { value: "status: Prox. do prazo de assinatura" },
  ];

  const columns = [
    "Tipo",
    "Empresa",
    "CNPJ",
    "Dt.Cadastro",
    "Dt.Prazo",
    "Status",
  ];

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  const handleViewSignatarios = () => {
    const iconStatus = (status) => {
      switch (status) {
        case "Pendente Assinatura": {
          return (
            <div className={styles.status}>
              <span className={styles.pendente} /> {status}
            </div>
          );
        }
        case "Assinado": {
          return (
            <div className={styles.status}>
              <span className={styles.assinado} /> {status}
            </div>
          );
        }
        case "Cancelado": {
          return (
            <div className={styles.status}>
              <span className={styles.cancelado} /> {status}
            </div>
          );
        }
      }
    };
    switch (stepSelected) {
      case 1:
        return (
          <>
            <DialogContent>
              <div>
                {right.length > 0 ? (
                  right.map((item) => (
                    <div key={item.id} className={styles.listSignatarios}>
                      <p>{item.nome}</p>
                      {iconStatus(item.status)}
                    </div>
                  ))
                ) : (
                  <p>Nenhum signatário encontrado!</p>
                )}
              </div>
            </DialogContent>
            <div className={styles.conteinerBtnSignatarios}>
              <WhiteButton
                clickFunction={() => handleOpenCloseSignatarios(false)}
                contentIcon={<CloseIcon />}
                textValue="Fechar"
                iconLeft
              />
              <BlueButton
                clickFunction={() => handleAlterStep(2)}
                contentStartIcon={<CompareArrowsIcon />}
                textValue="Alterar Signatários"
              />
            </div>
          </>
        );
      case 2:
        return (
          <>
            <Step2
              right={right}
              handleAvancar={() => {}}
              handleVoltar={() => {}}
              setRight={setRight}
              disableButtons
            />
            <div className={styles.conteinerBtnSignatarios}>
              <WhiteButton
                clickFunction={() => handleAlterStep(1)}
                contentIcon={<ArrowBackIcon />}
                textValue="Voltar"
                iconLeft
              />
              <BlueButton
                clickFunction={() => handleSubmitSaveSign()}
                contentStartIcon={<CheckIcon />}
                textValue="Salvar"
              />
            </div>
          </>
        );

      default:
        break;
    }
  };

  return (
    <>
      <Dialog
        open={openCancel}
        onClose={() => handleOpenCloseCancel(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <p className={styles.content_cancel}>
            Você está cancelando o contrato de:{" "}
            <strong>{contratoSelecionado.nomeEmpresa}</strong> Tem certeza que
            gostaria de seguir com o cancelamento deste contrato?
          </p>
          <div className={styles.conteinerBtnCancel}>
            <WhiteButton
              clickFunction={() => handleOpenCloseCancel(false)}
              contentIcon={<CloseIcon />}
              textValue="NÃO"
              iconLeft
            />
            <BlueButton
              clickFunction={() => handleCancelaContrato()}
              contentStartIcon={<CheckIcon />}
              textValue="SIM"
            />
          </div>
        </DialogContent>
      </Dialog>
      <Dialog // dialog para alterar a data de expiração
        open={openAlterar}
        onClose={() => setOpenAlterar(false)}
        maxWidth="xs"
        fullWidth
      >
        {!loading ? (
          <DialogContent>
            <p
              className={styles.content_alterar}
              contentIcon={<DateRangeIcon />}
            >
              Atualize a data de expiração
            </p>
            <GenericDatePicker
              textValue={selecionarData.value}
              onChange={handleAlterarData}
              error={selecionarData.error}
            />
            <div className={styles.conteinerBtnAlterar}>
              <WhiteButton
                clickFunction={() => handleOpenCloseAlterar(false)}
                contentIcon={<CloseIcon />}
                textValue="Cancelar"
                iconLeft
              />
              <BlueButton
                clickFunction={() => handleSubmitNewDate()}
                contentStartIcon={<CheckIcon />}
                textValue="Salvar"
              />
            </div>
          </DialogContent>
        ) : (
          <Loading loading={loading} />
        )}
      </Dialog>
      <ModalContratos
        handleOpen={openContrato}
        handleCLose={handleOpenCloseContrato}
        dadosUsuarios={dadosUsuarios}
      />
      <Dialog
        open={openSignatarios}
        onClose={() => handleOpenCloseSignatarios(false)}
        maxWidth="lg"
        fullWidth
      >
        <h2 className={styles.titleSignatarios}>
          {" "}
          <RecentActorsIcon sx={{ marginRight: ".5rem" }} />
          Signatários
        </h2>

        {loading ? <Loading loading={loading} /> : handleViewSignatarios()}
      </Dialog>
      <TableCard
        loading={loading}
        iconHeader={<HistoryEduIcon fontSize="1rem" />}
        titleHeader="Contratos"
        optionsFilter={optionsFilter}
        data={data}
        setData={setData}
        columns={columns}
        textHeaderCard="nome"
        handleDebounce={handleDebounce}
      />

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />
    </>
  );
};

export default Contratos;
